import React from 'react'
import { motion } from 'framer-motion'
import { ChevronRight, User } from 'lucide-react'
import { useLocation } from 'react-router-dom'

const PositionCard = ({ position, isSelected, isHighlighted, onClick, index }) => {
  // Определение цвета карточки по уровню
  const getLevelColor = (level) => {
    const colors = {
      1: 'from-red-50 to-red-100 border-red-200',      // Руководители
      2: 'from-orange-50 to-orange-100 border-orange-200', // Ведущие
      3: 'from-yellow-50 to-yellow-100 border-yellow-200', // Старшие
      4: 'from-green-50 to-green-100 border-green-200',    // Специалисты
      5: 'from-blue-50 to-blue-100 border-blue-200',       // Младшие
    }
    return colors[level] || 'from-gray-50 to-gray-100 border-gray-200'
  }

  // Анимация карточки
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        delay: index * 0.05
      }
    }
  }

  // Определение контекста просмотра (админ / публичный)
  const location = useLocation()
  const isAdminView = location.pathname.includes('/admin')

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`
        relative cursor-pointer p-3 rounded-lg transition-all duration-200
        ${isSelected 
          ? 'ring-2 ring-primary-500 shadow-lg bg-primary-50' 
          : isHighlighted 
            ? 'ring-2 ring-secondary-500 bg-secondary-50'
            : `bg-gradient-to-br ${getLevelColor(position.level)} hover:shadow-md`
        }
      `}
      onClick={onClick}
    >
      {/* Индикатор уровня */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center space-x-2">
          <User className="w-4 h-4 text-gray-500" />
          {isAdminView && (
            <span className="text-sm sm:text-xs font-medium text-gray-600">
              Уровень {position.level}
            </span>
          )}
        </div>
        <ChevronRight className="w-4 h-4 text-gray-400" />
      </div>

      {/* Название должности */}
      <h4 className="text-base sm:text-sm font-medium text-gray-800 leading-tight mb-1">
        {position.title}
      </h4>

      {/* Дополнительная информация */}
      {position.description && (
        <p className="text-sm sm:text-xs text-gray-600 line-clamp-2">
          {position.description}
        </p>
      )}

      {/* Анимированная подсветка для выбранной карточки */}
      {isSelected && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="absolute inset-0 bg-primary-500 opacity-5 rounded-lg pointer-events-none"
        />
      )}

      {/* Анимированная подсветка для связанных карточек */}
      {isHighlighted && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="absolute inset-0 bg-secondary-500 opacity-5 rounded-lg pointer-events-none"
        />
      )}
    </motion.div>
  )
}

export default PositionCard 